module.exports = __webpack_public_path__ + "static/media/Ice Tea - Latest.3d1355bd.jpg";